module.exports = __webpack_public_path__ + "static/media/gift_img.9d860545.png";